import React from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import { useNavigate } from 'react-router-dom';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: calc(100vh - 60px);
  background-color: #f0f0f0;
  padding: 20px;
  box-sizing: border-box;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 400px;
`;

const Button = styled.button`
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  border: none;

  &:hover {
    background-color: #0056b3;
  }
`;

const ImprimirPolizas: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header title="Imprimir Polizas" />
      <Wrapper>
        <Title>Seleccione la aseguradora</Title>
        <ButtonGroup>
          <Button onClick={() => navigate('/PolizaInput?aseguradora=Ana')}>Ana</Button>
          <Button onClick={() => navigate('/PolizaInput?aseguradora=Qualitas')}>Qualitas</Button>
          <Button onClick={() => navigate('/PolizaInput?aseguradora=Potosi')}>Potosi</Button>
        </ButtonGroup>
      </Wrapper>
    </>
  );
};

export default ImprimirPolizas;
